import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
var imgPath = '//media.4rgos.it/i/Argos'; // Argos Section Only

var AppFooter = function AppFooter(_ref) {
  var _ref$nativeLazy = _ref.nativeLazy,
      nativeLazy = _ref$nativeLazy === void 0 ? false : _ref$nativeLazy;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "https://apps.apple.com/gb/app/argos/id370371087",
    target: "_blank",
    rel: "noreferrer",
    "data-test": "footer-app-apple",
    style: {
      marginRight: '16px'
    },
    "aria-label": "Download the Argos app from the Apple Store"
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Apple Store",
    width: 117,
    height: 39,
    src: "".concat(imgPath, "/app-apple-prompt"),
    lazy: true,
    nativeLazy: nativeLazy,
    lazyWrapElement: "span"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.homeretailgroup.argos.android&hl=en",
    target: "_blank",
    rel: "noreferrer",
    "data-test": "footer-app-googleplay",
    "aria-label": "Download the Argos app from the Google Play Store"
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Google Play Store",
    width: 117,
    height: 39,
    src: "".concat(imgPath, "/app-google-prompt"),
    lazy: true,
    nativeLazy: nativeLazy,
    lazyWrapElement: "span"
  })));
};

AppFooter.propTypes = {
  nativeLazy: PropTypes.bool
};
export default AppFooter;